export default __webpack_public_path__ + "static/media/ies_Ledvance.86119633.png";